var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPlus@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHP-store-product-detailed",
    transform: "translate(-207.000000, -662.000000)",
    fill: "#666666",
    fillRule: "nonzero",
    stroke: "#F4F4F4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(118.000000, 663.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPlus",
    transform: "translate(90.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,50 C11.2144471,50 0,38.7855529 0,25 C0,11.2144471 11.2144471,0 25,0 C38.7855529,0 50,11.2144471 50,25 C50,38.7855529 38.7855529,50 25,50 Z M25,3.125 C12.9375458,3.125 3.125,12.9375458 3.125,25 C3.125,37.0624542 12.9375458,46.875 25,46.875 C37.0624542,46.875 46.875,37.0624542 46.875,25 C46.875,12.9375458 37.0624542,3.125 25,3.125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9375,26.5625 L14.0625,26.5625 C13.199997,26.5625 12.5,25.862503 12.5,25 C12.5,24.137497 13.199997,23.4375 14.0625,23.4375 L35.9375,23.4375 C36.800003,23.4375 37.5,24.137497 37.5,25 C37.5,25.862503 36.800003,26.5625 35.9375,26.5625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9375,26.5625 L14.0625,26.5625 C13.199997,26.5625 12.5,25.862503 12.5,25 C12.5,24.137497 13.199997,23.4375 14.0625,23.4375 L35.9375,23.4375 C36.800003,23.4375 37.5,24.137497 37.5,25 C37.5,25.862503 36.800003,26.5625 35.9375,26.5625 Z",
    id: "Path",
    transform: "translate(25.000000, 25.000000) rotate(90.000000) translate(-25.000000, -25.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/icPlus.da1c4c30ccb14ba67134b945e743371e.svg";
export { ForwardRef as ReactComponent };